import { Content, del, get, post, put } from '~/utils/ajax'

import { apiCheck, Shop } from '~/api'
import config from '~/config'

export * from './contracts'

export const updateChargebackData = async (ChargebackData: any) => await post(`chargeback/change`, ChargebackData)
